import React, { useEffect, useState, useRef } from 'react'
import { apiGet } from '../../generic/Api_Functions'
import { TextField, Grid, IconButton, MenuItem } from '@mui/material'
import { DeleteRounded } from '@mui/icons-material'

const SensorsActuatorsComponentsFunctionsProtocols = (props) => {
  const {
    ioElementSet,
    setIoElementSet,
    funcion,
    ioElementSetFunctionIoElement,
    addIoElementSetFunctionIoElement,
    setAddIoElementSetFunctionIoElement,
    setSaveDisabled,
    editMode
  } = props
  const [ioElements, setIoElements] = useState([])
  const [protocols, setProtocols] = useState([])
  const sensorActuatorValue = useRef()
  const errors = useRef([])

  useEffect(() => {
    const fetchData = async () => {
      const ioElementsDB = await apiGet('ioElement')
      setIoElements(ioElementsDB)
    }
    fetchData()
    const fetchProtocols = async () => {
      const protocolsDB = await apiGet('protocols')
      setProtocols(protocolsDB)
    }
    fetchProtocols()
  }, [ioElementSet])

  const ioElement = ioElementSetFunctionIoElement !== undefined ? ioElementSetFunctionIoElement.ioElement.id : ''

  const handleValue = (value) => {
    if (ioElements.length === 0) return ''
    if (value !== undefined) {
      sensorActuatorValue.current = value
      return value
    }
    if (ioElementSetFunctionIoElement !== undefined) {
      sensorActuatorValue.current = ioElementSetFunctionIoElement.ioElement.id
      return ioElementSetFunctionIoElement.ioElement.id
    }
    return ''
  }

  const getIoElementsToShow = () => {
    if (ioElements.length === 0) return ioElements

    if (ioElementSetFunctionIoElement === undefined) {
      return ioElements.filter(ioElement => {
        const ioElementFind = ioElementSet.ioElementSetFunctions
          .find((ioElementSetFunction) => ioElementSetFunction.function.code === funcion.code)
          .ioElementSetFunctionIoElements
          .find((ioElementForFunctionCode) => ioElementForFunctionCode.ioElement.id === ioElement.id)
        if (ioElementFind !== undefined) {
          return ioElement.id !== ioElementFind.ioElement.id
        }
        return true
      })
    } else {
      return ioElements
    }
  }

  const deleteIoElement = () => {
    if (ioElement === '') {
      setAddIoElementSetFunctionIoElement(false)
      return
    }
    const copyIoELementSet = { ...ioElementSet }
    const ioElementSetFunction = copyIoELementSet.ioElementSetFunctions.find(
      (ioElementSetFunction) => ioElementSetFunction.function.code === funcion.code
    )
    ioElementSetFunction.ioElementSetFunctionIoElements =
      ioElementSetFunction.ioElementSetFunctionIoElements.filter(
        ioElementSetFunctionIoElement => ioElementSetFunctionIoElement.ioElement.id !== ioElement
      )
    setIoElementSet(copyIoELementSet)
  }

  const handleChangeUpdateValue = (event, functionProtocolConfiguration) => {
    if (event.target.value === undefined || event.target.value === '') {
      setSaveDisabled(true)
    } else {
      setSaveDisabled(false)
    }
    functionProtocolConfiguration.protocolValue = event.target.value
  }

  const disabledFunction = () => {
    if (errors.current.length === 0) {
      setSaveDisabled(false)
    } else {
      setSaveDisabled(true)
    }
  }

  const handleChangeCreateValue = (event, protocol, controller, code) => {
    if (errors.current.find(error => error === code) !== undefined && event.target.value !== '') {
      errors.current = errors.current.filter((errorCopy) => errorCopy !== code)
    }

    let funcionProtocol
    let functionProtocolConfiguration

    if (protocol !== undefined && controller !== undefined) {
      functionProtocolConfiguration = {
        protocolParameter: protocol,
        protocolValue: event.target.value,
        functionProtocol: {
          function: funcion,
          protocol: controller.protocol
        }
      }
    }

    if (
      ioElementSetFunctionIoElement.ioElement.functionProtocol === undefined ||
      ioElementSetFunctionIoElement.ioElement.functionProtocol === null
    ) {
      funcionProtocol = {
        function: funcion,
        protocol: controller.protocol,
        functionProtocolConfigurations: [functionProtocolConfiguration]
      }
      ioElementSetFunctionIoElement.ioElement.functionProtocol = funcionProtocol
    } else {
      const foundConfig = ioElementSetFunctionIoElement.ioElement.functionProtocol.functionProtocolConfigurations
        .find(cfg => cfg.protocolParameter.parameter === protocol.parameter)
      if (foundConfig === undefined) {
        ioElementSetFunctionIoElement.ioElement.functionProtocol.functionProtocolConfigurations.push(functionProtocolConfiguration)
      } else {
        foundConfig.protocolValue = event.target.value
      }
    }
  }

  return (
    <Grid
      item
      xs={12}
      sx={{
        border: addIoElementSetFunctionIoElement ? '1px solid #7EE1A7' : '0px solid rgba(255, 255, 255, 0.12)',
        padding: '1em',
        borderRadius: '5px'
      }}
    >
      <Grid container direction='row' spacing={3} columns={{ xs: 1, sm: 4, md: 8, lg: 12 }}>
        <Grid item xs={2}>
          <TextField
            select
            label='Sensor/Actuator'
            value={handleValue()}
            disabled={sensorActuatorValue.current !== undefined}
            fullWidth
            onChange={(event) => {
              const ioElementNew = ioElements.find(ioElement => ioElement.id === event.target.value)
              const ioElementSetFUnctionIoElementNew = {
                ioElement: ioElementNew,
                ioElementSetFunction: {
                  id: ioElementSet.ioElementSetFunctions.find(
                    ioElementSetFunction => ioElementSetFunction.function.code === funcion.code
                  ).id
                }
              }
              ioElementSet.ioElementSetFunctions
                .find(ioElementSetFunction => ioElementSetFunction.function.code === funcion.code)
                .ioElementSetFunctionIoElements
                .unshift(ioElementSetFUnctionIoElementNew)
              handleValue(event.target.value)
              setIoElementSet(ioElementSet)
              if (setAddIoElementSetFunctionIoElement !== undefined) {
                setAddIoElementSetFunctionIoElement(false)
              }
            }}
          >
            {getIoElementsToShow().map((ioElement, index) => (
              <MenuItem value={ioElement.id} key={ioElement.id + index}>
                {ioElement.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        {ioElementSetFunctionIoElement !== undefined && (
          <>
            <Grid item xs={1.5}>
              <TextField
                label='Protocol'
                value={handleValue()}
                disabled={sensorActuatorValue.current !== undefined}
                fullWidth
              />
            </Grid>
            {ioElementSetFunctionIoElement?.ioElement?.functionProtocol !== undefined &&
            ioElementSetFunctionIoElement?.ioElement?.functionProtocol !== null
              ? (
                  ioElementSetFunctionIoElement.ioElement?.functionProtocol?.functionProtocolConfigurations
                    .sort((a, b) => a.id - b.id)
                    .map((functionProtocolConfiguration, index) => (
                      <Grid
                        key={functionProtocolConfiguration.protocolParameter?.parameter + index}
                        item
                        xs={
                          functionProtocolConfiguration.protocolParameter?.parameter === 'serverAddress' ||
                          functionProtocolConfiguration.protocolParameter?.parameter === 'variableName'
                            ? 3
                            : 2
                        }
                      >
                        <TextField
                          required
                          fullWidth
                          disabled={!editMode}
                          label={functionProtocolConfiguration?.protocolParameter?.parameter}
                          defaultValue={functionProtocolConfiguration?.protocolValue}
                          onChange={event => handleChangeUpdateValue(event, functionProtocolConfiguration)}
                        />
                      </Grid>
                    ))
                )
              : protocols.length !== 0
                ? (
                    protocols
                      .find(protocol => protocol.name === ioElementSetFunctionIoElement.ioElement?.ioController?.protocol?.name)
                      ?.protocolParameters
                      ?.sort((a, b) => a.id - b.id)
                      .map((protocolParameter, index) => (
                        <Grid
                          key={protocolParameter.parameter + index}
                          item
                          xs={
                            protocolParameter.parameter === 'serverAddress' ||
                            protocolParameter.parameter === 'variableName'
                              ? 3
                              : 2
                          }
                        >
                          <TextField
                            required
                            fullWidth
                            disabled={!editMode}
                            label={protocolParameter.parameter}
                            onChange={event =>
                              handleChangeCreateValue(
                                event,
                                protocolParameter,
                                ioElementSetFunctionIoElement.ioElement.ioController,
                                funcion.code + ioElementSetFunctionIoElement.ioElement.code + protocolParameter.parameter
                              )}
                            onBlur={disabledFunction}
                          />
                        </Grid>
                      ))
                  )
                : null}
          </>
        )}
        <Grid item xs={0.5}>
          <IconButton style={{ color: editMode ? 'white' : 'gray' }} onClick={deleteIoElement} disabled={!editMode}>
            <DeleteRounded />
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default SensorsActuatorsComponentsFunctionsProtocols
